import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/productpage.css";

function ProductPage() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [inquiryData, setInquiryData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submissionStatus, setSubmissionStatus] = useState(null);

  useEffect(() => {
    async function loadProduct() {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          "https://d3ejxze7429gw1.cloudfront.net/products"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const selectedProduct = data.find((p) => p.id === productId);
        if (selectedProduct) {
          setProduct(selectedProduct);
        } else {
          setError("Product not found");
        }
      } catch (e) {
        setError(e.message);
        console.error("Could not fetch product:", e);
      } finally {
        setLoading(false);
      }
    }
    loadProduct();
  }, [productId]);

  const handleInquiryChange = (e) => {
    const { name, value } = e.target;
    setInquiryData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://d3ejxze7429gw1.cloudfront.net/submit-inquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(inquiryData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSubmissionStatus("Inquiry submitted successfully!");
        setInquiryData({ name: "", email: "", message: "" });
      } else {
        setSubmissionStatus(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
      setSubmissionStatus("An error occurred while submitting your inquiry.");
    }
    setShowModal(false);
  };

  if (loading) {
    return (
      <div className="product-page-container">Loading product details...</div>
    );
  }

  if (error) {
    return <div className="product-page-container">Error: {error}</div>;
  }

  if (!product) {
    return <div className="product-page-container">Product not found.</div>;
  }

  return (
    <div className="product-page-container">
      <div className="product-content">
        <div className="product-image-container">
          <img
            src={`https://d3ejxze7429gw1.cloudfront.net${product.imageUrl}`}
            alt={product.title}
            className="product-image"
          />
        </div>

        <div className="product-details">
          <h1 className="product-title">{product.title}</h1>
          <p className="product-description">{product.description}</p>
          <h2 className="specifications-title">Specifications</h2>
          <ul className="specifications-list">
            <p>Size: {product.specifications.size}</p>

            <p>Material: {product.specifications.material}</p>
            <p>Price: {product.price}€</p>
          </ul>

          <div className="product-buttons">
            <button
              className="inquire-button"
              onClick={() => setShowModal(true)}
            >
              Inquire About This Product
            </button>

            <a
              href={`https://shop.ronniceramics.com/pre-order/${product.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="preorder-button"
            >
              Pre-Order Now
            </a>
          </div>
        </div>
      </div>

      {submissionStatus && (
        <div className="submission-status">{submissionStatus}</div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Product Inquiry</h2>
            <form onSubmit={handleInquirySubmit}>
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={inquiryData.name}
                onChange={handleInquiryChange}
                required
              />

              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={inquiryData.email}
                onChange={handleInquiryChange}
                required
              />

              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                name="message"
                value={inquiryData.message}
                onChange={handleInquiryChange}
                required
              />

              <button type="submit">Submit Inquiry</button>
              <button type="button" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductPage;
